/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/jss/bootstrap.js to modify the generation of this file.
export default {
  "sitecoreApiKey": "{020EFD69-08D4-44AE-BC20-16285EBCBEBF}",
  "sitecoreApiHost": "",
  "sitecoreApiHostNonPep": "",
  "sitecoreApiHostStaging": "",
  "jssAppName": "memberportal",
  "sitecoreApi": {
    "apiPathMemberLogin": "/api/login",
    "apiPathMemberLogout": "/api/logout",
    "apiPathMemberRefreshToken": "/api/refreshtoken",
    "apiPathMemberLoginClassic": "/api/loginpassword",
    "apiPathMemberDeviceLogin": "/api/loginpushnotify",
    "apiPathMemberPushInitiate": "/api/loginpushinitiate",
    "apiPathMemberPushAccountCheck": "/api/loginpushaccountcheck",
    "apiPathMemberPushDeviceCheck": "/api/loginpushdevicecheck",
    "apiPathMemberPushPollingWait": "/api/loginpushpollingwait",
    "apiPathMemberPushResend": "/api/loginpushresend",
    "apiPathMemberLoginPush": "/api/loginpush",
    "apiPathMemberAnnualInvestmentPerformance": "/api/investment-performance/annual-rates",
    "apiPathMemberLoginValidateOtp": "/api/validateOtp",
    "apiPathMemberLoginSendOtp": "/api/sendOtp",
    "apiPathMemberLoginTrustDevice": "/api/logintrustdevice"
  },
  "australianSuperApi": {
    "apiDomain": "https://apis-v5.australiansuper.com",
    "apiPathAccount": "/account/v1",
    "apiPathBeneficiaries": "/beneficiary/v1",
    "apiPathDocument": "/document/v1",
    "apiPathForm": "/form/v1",
    "apiPathIdentity": "/identity/v1",
    "apiPathInvestment": "/investment/v1",
    "apiPathMember": "/member/v1",
    "apiPathOtp": "/otp/v1",
    "apiPathOutboundCommunication": "/communications/outbound-communication-system/v1",
    "apiPathPayment": "/payment/v1",
    "apiPathReferenceData": "/reference-data/v1",
    "apiPathTransaction": "/transaction/v1",
    "apiPathExpTransaction": "{AUS_API_PATH_TRANSACTION_EXPORT}",
    "apiPathTransactionSummary": "/transaction/v1",
    "apiPathInsurance": "/insurance/v1",
    "apiPathPartner": "/partner/v1",
    "apiPathTransactionExperience": "/exp-transaction/v1",
    "apiPathDocumentAnnualStatement": "/document/annual-statement/v1",
    "apiPathSignificantEventNotice": "/document/significant-event-notice/v1",
    "apiPathCommunicationPreference": "/communications/preference/v1",
    "apiPathRegistration": "/registration-exp/v1",
    "apiPathNotifyEmployer": "/notify-employer/v1",
    "apiPathWithdrawals": "/withdrawal/v1",
    "apiPathSystemIdentityVerification": "/identity-verification/v1",
    "apiPathSystemValidation": "/system-validation/v1",
    "apiPathAddressValidation": "/address-validation/v1",
    "apiPathRollover": "/rollover/v1",
    "apiPathNoi": "/contributions/v1",
    "apiPathContributions": "/contributions/v1",
    "apiPathSystemAudit": "/audit-system/v1",
    "apiPathSystemMemberRestriction": "/member-restriction-system/v1",
    "apiPathMemberExperience": "/exp-member/v1"
  },
  "externalServices": {
    "azureAppInsightsInstrumentationKey": "20abfedc-fb09-4c10-a036-d504b800eaae",
    "coarseGrainApiKey": "6d7f4b17-d97e-47af-b5ae-cb696ef3c2df",
    "postAuditStaticIPAddress": "20.211.64.9",
    "greenIdAssetsUrl": "https://simpleui-test-au.vixverify.com",
    "daonDomain": "https://aussuperprod.aussuper.trustx.com",
    "daonTrustWebPath": "/web/trustweb?ps=",
    "daonStartProcessPath": "/api/process-server/startProcess?pi="
  },
  "defaultLanguage": "en"
};